import React from 'react'
import styled from 'styled-components'
import Container from '../container'
import White from '../white'
import Black from '../black'
import Portable from '../portable'

import Knots from '../../images/knots.svg'
import CelticMap from '../../images/celtic_map.svg'

const Outer = styled.div`
  border: 1px solid #000;
  background-color: #000;
  padding-top: 0px;
`

const Flex = styled.div`
  display: flex;
  justify-content: space-between;
  column-gap: 20px;
  border-radius: 20px;
`

const KnotContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  padding-left: 1rem;
  padding-right: 1rem;
  margin-bottom: 110px;
`

const Celtic = styled.div`
  display: flex;
  justify-content: space-between;
  max-width: 1007px;
  margin: 0 auto;
  margin-bottom: 170px;
  @media(max-width: 768px) {
    flex-direction: column;
    margin-bottom: 1rem;
  }
  div.left {
    width: 100%;
    color: #fff;
    max-width: 537px;
    display: flex;
    align-items: center;
    @media(max-width: 768px) {
      padding-left: 1rem;
      padding-right: 1rem;
    }
  }
  div.right {
    @media(max-width: 768px) {
      padding-left: 1rem;
      padding-right: 1rem;
      img {
        margin: 0 auto;
        padding-top: 2rem;
        padding-bottom: 2rem;
        max-height: 500px;
      }
    }
  }
`

const LargeImage = ({module}) => {
  return (
    <Outer>

      <KnotContainer>
        <img src={Knots} alt="" />
      </KnotContainer>

      <Celtic>
        <div className="left">
          <Portable blocks={module.body} />
        </div>
        <div className="right"><img src={CelticMap} alt="" /></div>
      </Celtic>

    </Outer>
  )
}

export default LargeImage
